import {useMemo} from 'react'
import {useCache} from './use_cache'
import utils from '@eitje/utils'

export const useVisibleColumns = ({tableName, allTableColumns, defaultVisibleColumns}) => {
	const visibleCache = useCache({tableName}).visible
	return useMemo(
		() => filterVisibleColumns(visibleCache || [], allTableColumns, defaultVisibleColumns),
		[visibleCache, allTableColumns, defaultVisibleColumns],
	)
}

// Use this memoized function to maintain object reference integrity, since without it, the array of columnNames
// would cause infinite loops when used as dependency in a useEffect hook.
const filterVisibleColumns = (cache, allTableColumns, defaultVisibleColumns) => {
	const hasSavedPreferences = utils.exists(cache)
	const hasDefaults = utils.exists(defaultVisibleColumns)

	// Simply return the stored user preference if present.
	if (hasSavedPreferences) return allTableColumns.filter(column => cache.includes(column)).uniq()

	// For performance, some tables have defaults - prefer them over showing all columns.
	if (hasDefaults) return defaultVisibleColumns

	// Simply show all columns otherwise.
	return allTableColumns
}
